// @ts-strict-ignore
import { FulfillmentStatus } from "@dashboard/graphql";
import useNavigator from "@dashboard/hooks/useNavigator";
import { orderPaymentRefundUrl } from "@dashboard/orders/urls";
import { CardActions } from "@material-ui/core";
import { Button } from "@saleor/macaw-ui-next";
import { FormattedMessage } from "react-intl";

import { actionButtonsMessages } from "./messages";
import useStyles from "./styles";

// "Approve fulfillment" and the initial "Add tracking number" actions now live
// in the order progress stepper so all order-progression controls sit in one
// guided place. This card keeps only the per-fulfillment corrections: editing an
// already-set tracking number and refunding a returned fulfillment.
interface AcionButtonsProps {
  orderId: string;
  status: FulfillmentStatus;
  trackingNumber?: string;
  hasTransactions: boolean;
  onTrackingCodeAdd: () => any;
}

const ActionButtons = ({
  orderId,
  status,
  trackingNumber,
  hasTransactions,
  onTrackingCodeAdd,
}: AcionButtonsProps) => {
  const classes = useStyles();
  const navigate = useNavigator();
  const hasTrackingNumber = !!trackingNumber;

  const handleRefundClick = () => {
    navigate(orderPaymentRefundUrl(orderId));
  };

  if (status === FulfillmentStatus.RETURNED && !hasTransactions) {
    return (
      <CardActions>
        <Button onClick={handleRefundClick} variant="primary">
          <FormattedMessage {...actionButtonsMessages.refund} />
        </Button>
      </CardActions>
    );
  }

  if (!hasTrackingNumber) {
    return null;
  }

  return (
    <CardActions className={classes.actions}>
      <Button data-test-id="edit-tracking-button" variant="primary" onClick={onTrackingCodeAdd}>
        <FormattedMessage {...actionButtonsMessages.editTracking} />
      </Button>
    </CardActions>
  );
};

export default ActionButtons;
